import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getFacilityListAction,
  getProviderProfileDetailAction,
  getTestDetailNewPopupAction,
  getTestDetailUpdatePopupAction,
} from "../../../redux/actions/ProviderProfileDetailAction";
import Modal from "react-modal";
import { ConfirmationTestPopup } from "./ConfirmationTestPopup";
import { getTagListNetworkAction } from "../../../redux/actions/TestPackageNetworkAction";
import CustomPagination from "../../../common/CustomPagination";
import { TableHeaderAdmin } from "../HelloAdmin/helper";

const initialHeader = [
  "HA SKU Code",
  "HA SKU Name",
  "Walk In Price",
  "MRP (Rs.)",
];
const newAddHeaderArray = [
  "Agreed Rate",
  "Outsourced",
  "Centre Test Code",
  "Centre Test Name",
  "Test Type",
  "HV Charges For",
];
const updateAddHeaderArray = [
  "Agreed Rate",
  "Existing Agreed Rate",
  "Outsourced",
  "Centre Test Code",
  "Centre Test Name",
  "Test Type",
  "HV Charges For",
];

export const TestDetailsPopup = ({
  rowData,
  searchFilter,
  apiParams,
  setRowData,
}) => {
  const dispatch = useDispatch();
  const [newHeaderArray, setNewHeaderArray] = useState(initialHeader);
  const [updateHeaderArray, setUpdateHeaderArray] = useState(initialHeader);
  const [isApproveReject, setIsApproveReject] = useState(null);
  const [newSearchFilterTest, setNewSearchFilterTest] = useState({
    ticketId: rowData?.requestID,
    SessionId: rowData?.sessionID,
    page: 1,
    rows: 10,
    SortDirection: "DESC",
    SortColumn: "",
    ActionFlag: "A",
  });
  const [updateSearchFilterTest, setUpdateSearchFilterTest] = useState({
    ticketId: rowData?.requestID,
    SessionId: rowData?.sessionID,
    page: 1,
    rows: 10,
    SortDirection: "DESC",
    SortColumn: "",
    ActionFlag: "U",
  });
  const providerPortalDetailReducer = useSelector(
    (state) => state?.providerPortalDetailReducer
  );

  useEffect(() => {
    dispatch(getTestDetailNewPopupAction(newSearchFilterTest));
    dispatch(getTestDetailUpdatePopupAction(updateSearchFilterTest));
    dispatch(getFacilityListAction("TEST", rowData?.providerID));
    dispatch(getTagListNetworkAction());
  }, []);

  const handleClose = () => {
    dispatch(getProviderProfileDetailAction({ ...searchFilter, ...apiParams }));
    setRowData(null);
  };

  const SortHandler = (sortColumnName, sortDirection) => {
    setNewSearchFilterTest({
      ...newSearchFilterTest,
      page: 1,
      SortColumn: sortColumnName,
      sortDirection: sortDirection,
    });
    dispatch(
      getTestDetailNewPopupAction({
        ...newSearchFilterTest,
        page: 1,
        SortColumn: sortColumnName,
        sortDirection: sortDirection,
      })
    );
  };
  const UpdateSortHandler = (sortColumnName, sortDirection) => {
    setUpdateSearchFilterTest({
      ...updateSearchFilterTest,
      page: 1,
      SortColumn: sortColumnName,
      sortDirection: sortDirection,
    });
    dispatch(
      getTestDetailUpdatePopupAction({
        ...updateSearchFilterTest,
        page: 1,
        SortColumn: sortColumnName,
        sortDirection: sortDirection,
      })
    );
  };

  return (
    <>
      <div className="modal-body" style={{ height: "100%" }}>
        <div className="back-buttondiv" onClick={handleClose}>
          <i className="fa-solid fa-circle-arrow-left"></i>
          <h6 style={{ cursor: "pointer" }}>Back</h6>
        </div>
        <div>
          <h4
            className="font-bold text-highlight"
            style={{ letterSpacing: "1px" }}
          >
            Test Details ({rowData?.providerName})
          </h4>
        </div>
        {providerPortalDetailReducer?.getTestDetailNewPage?.skuDetails
          ?.length ? (
          <>
            <div className="flexbetween_center">
              <h5 className="mt-4">New Tests</h5>
              <div>
                <input
                  type="checkbox"
                  className="form-check-input"
                  onClick={(e) =>
                    e.target.checked
                      ? setNewHeaderArray([
                          ...newHeaderArray,
                          ...newAddHeaderArray,
                        ])
                      : setNewHeaderArray(initialHeader)
                  }
                  checked={newHeaderArray?.length === 10}
                />
                <label
                  className="margin-right"
                  style={{ marginLeft: "10px", fontWeight: "600" }}
                >
                  Table Extended View
                </label>
              </div>
            </div>
            <div className="table-responsive __custom__properties mt-4">
              <table className="table">
                <thead>
                  <tr className="avanishtbl">
                    {newHeaderArray?.map((ele, index) => {
                      return (
                        <TableHeaderAdmin
                          key={index}
                          header={ele}
                          searchFilter={newSearchFilterTest}
                          SortHandler={SortHandler}
                        />
                      );
                    })}
                    {rowData?.detailType === "TestDetail" ? <th>Source</th> : <th>App Price</th>}
                    <th>Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {providerPortalDetailReducer?.getTestDetailNewPage?.skuDetails?.map(
                    (ele, index) => {
                      return (
                        <tr key={index}>
                          <td>{ele?.facilityId}</td>
                          <td>{ele?.facilityName}</td>
                          <td>{ele?.walkInPrice}</td>
                          <td>{ele?.mrp}</td>
                          
                          {newHeaderArray?.length === 10 && (
                            <>
                              <td>{ele?.agreedRate}</td>
                              <td>{ele?.isOutSourced ? "Yes" : "No"}</td>
                              <td>{ele?.centreSKUCode}</td>
                              <td>{ele?.centreSKUName}</td>
                              <td>{ele?.testType}</td>
                              <td>{ele?.hvChargesFor}</td>
                            </>
                          )}
                          {rowData?.detailType === "TestDetail" ?<td>{ele?.source}</td> : <td>{ele?.appPrice1Graded}</td>}
                          <td>
                            <p
                              className={`status-style ${
                                ele?.requestStatus === "Accepted"
                                  ? "approved"
                                  : ele?.requestStatus === "Rejected"
                                  ? "rejected"
                                  : ele?.requestStatus === "InProgress"
                                  ? "notsubmited-status"
                                  : "pending"
                              }`}
                            >
                              {ele?.requestStatus}
                            </p>
                          </td>
                          <td
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setIsApproveReject({ ...ele, index: index });
                            }}
                          >
                            <img src="./images/edit-icon.png" alt="" />
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
              <div className="d-flex mt-4">
                {providerPortalDetailReducer?.getTestDetailNewPage?.totalRow !==
                  0 && (
                  <CustomPagination
                    totalCount={
                      providerPortalDetailReducer?.getTestDetailNewPage
                        ?.totalRow
                    }
                    perPageData={newSearchFilterTest?.rows}
                    searchFilter={newSearchFilterTest}
                    setSearchFilter={setNewSearchFilterTest}
                    apiCall={getTestDetailNewPopupAction}
                  />
                )}
              </div>
            </div>
          </>
        ) : null}
        {providerPortalDetailReducer?.getTestDetailUpdatePage?.skuDetails
          ?.length ? (
          <>
            <div className="flexbetween_center">
              <h5 className="mt-4">Existing Tests</h5>
              <div>
                <input
                  type="checkbox"
                  className="form-check-input"
                  onClick={(e) =>
                    e.target.checked
                      ? setUpdateHeaderArray([
                          ...updateHeaderArray,
                          ...updateAddHeaderArray,
                        ])
                      : setUpdateHeaderArray(initialHeader)
                  }
                  checked={updateHeaderArray?.length === 11}
                />
                <label
                  className="margin-right"
                  style={{ marginLeft: "10px", fontWeight: "600" }}
                >
                  Table Extended View 
                </label>
              </div>
            </div>
            <div className="table-responsive __custom__properties mt-4">
              <table className="table">
                <thead>
                  <tr className="avanishtbl">
                    {updateHeaderArray?.map((ele, index) => {
                      return (
                        <TableHeaderAdmin
                          key={index}
                          header={ele}
                          searchFilter={updateSearchFilterTest}
                          SortHandler={UpdateSortHandler}
                        />
                      );
                    })}
                     {rowData?.detailType === "TestDetail" ? <th>Source</th> : <th>App Price</th>}
                    <th>Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {providerPortalDetailReducer?.getTestDetailUpdatePage?.skuDetails?.map(
                    (ele, index) => {
                      return (
                        <tr key={index}>
                          <td>{ele?.facilityId}</td>
                          <td>{ele?.facilityName}</td>
                          <td>{ele?.walkInPrice}</td>
                          <td>{ele?.mrp}</td>
                          {updateHeaderArray?.length === 11 && (
                            <>
                              <td>{ele?.agreedRate}</td>
                              <td>{ele?.existingAgreedRate}</td>
                              <td>{ele?.isOutSourced ? "Yes" : "No"}</td>
                              <td>{ele?.centreSKUCode}</td>
                              <td>{ele?.centreSKUName}</td>
                              <td>{ele?.testType}</td>
                              <td>{ele?.hvChargesFor}</td>
                            </>
                          )}
                          {rowData?.detailType === "TestDetail" ?<td>{ele?.source}</td> : <td>{ele?.appPrice1Graded}</td>}
                          <td>
                            <p
                              className={`status-style ${
                                ele?.requestStatus === "Accepted"
                                  ? "approved"
                                  : ele?.requestStatus === "Rejected"
                                  ? "rejected"
                                  : ele?.requestStatus === "InProgress"
                                  ? "notsubmited-status"
                                  : "pending"
                              }`}
                            >
                              {ele?.requestStatus}
                            </p>
                          </td>
                          <td
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setIsApproveReject({ ...ele, index: index });
                            }}
                          >
                            <img src="./images/edit-icon.png" alt="" />
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
              <div className="d-flex mt-4">
                {providerPortalDetailReducer?.getTestDetailUpdatePage
                  ?.totalRow !== 0 && (
                  <CustomPagination
                    totalCount={
                      providerPortalDetailReducer?.getTestDetailUpdatePage
                        ?.totalRow
                    }
                    perPageData={updateSearchFilterTest?.rows}
                    searchFilter={updateSearchFilterTest}
                    setSearchFilter={setUpdateSearchFilterTest}
                    apiCall={getTestDetailUpdatePopupAction}
                  />
                )}
              </div>
            </div>
          </>
        ) : null}
      </div>
      <Modal
        isOpen={isApproveReject}
        className="modal-add-user-popup modal-role-user-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <ConfirmationTestPopup
          isApproveReject={isApproveReject}
          setIsApproveReject={setIsApproveReject}
          rowData={rowData}
          handleClose={handleClose}
          newSearchFilterTest={newSearchFilterTest}
          updateSearchFilterTest={updateSearchFilterTest}
        />
      </Modal>
    </>
  );
};
